import Parse from 'parse'
import moment from 'moment'

const state = {
  schoolPackage: null,
  schoolInstructors: null,
  schoolPackageJoined: null,
  schoolPackageJoinedUpdate: null,
  schoolPackageJoinedId: null,
  paymenthistory: null,
  completedHours: null,
  requestCertificate: null,
  certificate: null,
  schools: null,
  assignedInstructors: null,
  assignedStudents: null
}

const getters = {
  schoolPackage: (state) => state.schoolPackage,
  schoolInstructors: (state) => state.schoolInstructors,
  schoolPackageJoined: (state) => state.schoolPackageJoined,
  schoolPackageJoinedUpdate: (state) => state.schoolPackageJoinedUpdate,
  schoolPackageJoinedId: (state) => state.schoolPackageJoinedId,
  paymenthistory: (state) => state.paymenthistory,
  completedHours: (state) => state.completedHours,
  requestCertificate: (state) => state.requestCertificate,
  certificate: (state) => state.certificate,
  schools: (state) => state.schools,
  assignedInstructors: (state) => state.assignedInstructors,
  assignedStudents: (state) => state.assignedStudents
}

const actions = {
  async getSchools ({ commit }) {
    /** @todo: need to filter schools by location/distance */
    const filteredSchoolsEntries = []
    var SchoolsClass = Parse.Object.extend('Schools')
    var query = new Parse.Query(SchoolsClass)
    query.ascending('name')
    query.equalTo('approvedByAdmin', 'Approved')
    query.include('associatedId')

    var User = Parse.Object.extend('User')
    var innerQuery = new Parse.Query(User)
    // innerQuery.exists("stripeSubscriptionId");
    query.matchesQuery('associatedId', innerQuery)
    query.limit(50)

    await query
      .find()
      .then((scls) => {
        console.log(scls.length)
        let promise = Promise.resolve()
        /** Check if this school has valid subscription */
        Object.keys(scls).forEach((key) => {
          if (typeof scls[key].get('associatedId').get('stripeSubscriptionId') !== 'undefined' && scls[key].get('associatedId').get('stripeSubscriptionId') !== '') {
            var sData = {
              subscriptionId: scls[key]
                .get('associatedId')
                .get('stripeSubscriptionId')
            }
            /** call the cloud fundtion */
            promise = Parse.Cloud.run('getSubscription', sData).then(
              function (currentSub) {
                if (currentSub.status === 'active') {
                  filteredSchoolsEntries.push(scls[key])
                }
              },
              (error) => {
                console.log(error.message)
              }
            )
          } else if (scls[key].get('associatedId').get('trial')) {
            /** Check if the trial is expired or not */
            const trialEndDate = moment(scls[key].get('associatedId').get('trialBegun'),
              'DD-MM-YYYY'
            ).add(60, 'days')
            const todaysdate = moment()
            var daysToGo = trialEndDate.diff(todaysdate, 'days')
            if (daysToGo > 0) {
              filteredSchoolsEntries.push(scls[key])
            }
          }
        })
        return promise
      })
      .then(() => {
        /** Finally */
        console.log(filteredSchoolsEntries)
        commit('setSchools', filteredSchoolsEntries)
      })
      .catch((e) => {
        console.log(e)
        commit('setSchools', false)
      })
  },

  async getSchoolPackageFromId ({ commit }, payload) {
    const SchoolPackages = Parse.Object.extend('SchoolPackages')
    const query = new Parse.Query(SchoolPackages)
    query.equalTo('objectId', payload.schoolPackageId)
    query.include('schoolId')
    query.include('schoolId.associatedId')
    try {
      const response = await query.first()
      if (response) {
        commit('setSchoolPackage', response)
      } else {
        commit('setSchoolPackage', false)
      }
    } catch (error) {
      console.log(error)
      commit('setSchoolPackage', false)
    }
  },
  async getSchoolInstructors ({ commit }, payload) {
    const instructorIds = []
    const InstructorSchools = Parse.Object.extend('InstructorSchools')
    const query = new Parse.Query(InstructorSchools)
    console.log(payload.schoolId)
    const Schools = Parse.Object.extend('Schools')
    const SchoolsPointerId = new Schools()
    SchoolsPointerId.id = payload.schoolId
    query.equalTo('schoolId', SchoolsPointerId)
    query.include('instructorId')

    await query
      .find()
      .then((response) => {
        console.log(response.length)
        if (response.length) {
          Object.keys(response).forEach((key) => {
            if (response[key]) {
              instructorIds.push(response[key].get('instructorId').id)
            }
          })
        }
        return instructorIds
      })
      .then(function (instructorsArr) {
        if (instructorsArr.length) {
          const UserClass = Parse.Object.extend('User')
          const query = new Parse.Query(UserClass)
          /** @Todo need to verify if we need these 2 conditions here */
          query.exists('stripeUserAccountId')
          // query.equalTo('stripeSubscriptionActive', true)
          query.equalTo('packageAdded', true)
          query.containedIn('objectId', instructorsArr)
          query.equalTo('status', true)
          query.limit(15)
          const response = query.find()
          return response
        } else {
          return instructorsArr
        }
      })
      .then(function (finalResult) {
        commit('setSchoolInstructors', finalResult)
      })
      .catch(function (error) {
        commit('setSchoolInstructors', error)
      })
  },
  async addSchoolPackage ({ commit }, payload) {
    /** Check if this same records already saved, then just return the ID */
    const SchoolPackageJoined = Parse.Object.extend('SchoolPackageJoined')
    const query = new Parse.Query(SchoolPackageJoined)

    const User = Parse.Object.extend('User')
    const UserPointerId = new User()
    UserPointerId.id = payload.studentId
    query.equalTo('studentId', UserPointerId)

    const Schools = Parse.Object.extend('Schools')
    const SchoolsPointerId = new Schools()
    SchoolsPointerId.id = payload.schoolId
    query.equalTo('schoolId', SchoolsPointerId)

    const SchoolPackages = Parse.Object.extend('SchoolPackages')
    const SchoolPackagesPointerId = new SchoolPackages()
    SchoolPackagesPointerId.id = payload.schoolPackageId
    query.equalTo('schoolPackageId', SchoolPackagesPointerId)

    try {
      const response = await query.first()
      if (response) {
        commit('setSchoolPackageJoined', response.id)
      } else {
        var saveSchoolPackageJoined = new SchoolPackageJoined()
        saveSchoolPackageJoined.set('studentId', UserPointerId)
        saveSchoolPackageJoined.set('schoolId', SchoolsPointerId)
        saveSchoolPackageJoined.set('schoolPackageId', SchoolPackagesPointerId)
        saveSchoolPackageJoined.set('status', false)

        await saveSchoolPackageJoined.save().then(
          (saveSchoolPackageJoined) => {
            commit('setSchoolPackageJoined', saveSchoolPackageJoined.id)
          },
          (error) => {
            console.log(error)
            commit('setSchoolPackageJoined', false)
          }
        )
      }
    } catch (error) {
      console.log(error)
      commit('setSchoolPackageJoined', false)
    }
  },

  /** Get school package from student id */
  async getSchoolPackageJoinedById ({ commit }, payload) {
    /** Check if this same records already saved, then just return the ID */
    const SchoolPackageJoined = Parse.Object.extend('SchoolPackageJoined')
    const query = new Parse.Query(SchoolPackageJoined)

    const User = Parse.Object.extend('User')
    const UserPointerId = new User()
    UserPointerId.id = payload.studentId
    query.equalTo('studentId', UserPointerId)
    query.equalTo('status', true)
    query.include('schoolId.associatedId')
    try {
      const response = await query.first()
      if (response) {
        commit('setSchoolPackageJoinedId', response)
      } else {
        commit('setSchoolPackageJoinedId', false)
      }
    } catch (error) {
      console.log(error)
      commit('setSchoolPackageJoinedId', false)
    }
  },

  async getCompletedHours ({ commit }, payload) {
    const Appointments = Parse.Object.extend('Appointments')
    const query = new Parse.Query(Appointments)

    const User = Parse.Object.extend('User')
    const UserPointerId = new User()
    UserPointerId.id = payload.studentId
    query.equalTo('studentId', UserPointerId)

    const SchoolPackages = Parse.Object.extend('SchoolPackages')
    const SchoolPackagesPointerId = new SchoolPackages()
    SchoolPackagesPointerId.id = payload.schoolPackageId
    query.equalTo('schoolPackageId', SchoolPackagesPointerId)

    query.equalTo('status', 'Finished')
    query.equalTo('paid', true)

    try {
      const response = await query.count()
      commit('setCompletedHours', response)
    } catch (error) {
      console.log(error)
      commit('setCompletedHours', false)
    }
  },

  async updateSchoolPackage ({ commit }, payload) {
    /** Check if this same records already saved, then just return the ID */
    const SchoolPackageJoined = Parse.Object.extend('SchoolPackageJoined')
    var saveSchoolPackageJoined = new SchoolPackageJoined()
    saveSchoolPackageJoined.id = payload.id
    saveSchoolPackageJoined.set('status', true)

    await saveSchoolPackageJoined.save().then(
      (saveSchoolPackageJoined) => {
        console.log(saveSchoolPackageJoined)
        commit('setSchoolPackageJoinedUpdate', true)
      },
      (error) => {
        console.log(error)
        commit('setSchoolPackageJoinedUpdate', false)
      }
    )
  },

  async addPayentHistory ({ commit }, payload) {
    const PaymentHistories = Parse.Object.extend('PaymentHistories')
    var savePaymentHistories = new PaymentHistories()

    const User = Parse.Object.extend('User')
    const UserPointerId = new User()
    UserPointerId.id = payload.senderId
    savePaymentHistories.set('senderId', UserPointerId)

    const ReceiverClass = Parse.Object.extend('User')
    const receiverPointerId = new ReceiverClass()
    receiverPointerId.id = payload.receiverId
    savePaymentHistories.set('receiverId', receiverPointerId)

    savePaymentHistories.set('amount', payload.amount)
    savePaymentHistories.set('associaatedId', payload.associaatedId)
    savePaymentHistories.set('stripePaymentId', payload.stripePaymentId)
    savePaymentHistories.set('notes', payload.notes)
    savePaymentHistories.set('type', [payload.type])
    savePaymentHistories.set('paymentDate', new Date())
    savePaymentHistories.set('status', true)

    await savePaymentHistories.save().then(
      (savePaymentHistories) => {
        console.log(savePaymentHistories)
        commit('setPaymentHistory', true)
      },
      (error) => {
        console.log(error)
        commit('setPaymentHistory', false)
      }
    )
  },

  async addRequestCertificate ({ commit }, payload) {
    const Certificates = Parse.Object.extend('Certificates')
    const query = new Parse.Query(Certificates)

    const User = Parse.Object.extend('User')
    const UserPointerId = new User()
    UserPointerId.id = payload.userId
    query.equalTo('studentId', UserPointerId)

    const Schools = Parse.Object.extend('Schools')
    const SchoolsPointerId = new Schools()
    SchoolsPointerId.id = payload.schoolId
    query.equalTo('schoolId', SchoolsPointerId)

    try {
      const response = await query.first()
      if (response) {
        commit('setRequestCertificate', response)
        commit('setCertificate', response)
      } else {
        var saveCertificates = new Certificates()
        saveCertificates.set('studentId', UserPointerId)
        saveCertificates.set('schoolId', SchoolsPointerId)
        saveCertificates.set('tenHoursLesson', true)
        saveCertificates.set('courseCompleted', true)
        saveCertificates.set('status', false)

        await saveCertificates.save().then(
          (saveCertificates) => {
            /** Send certificate request email to the school */
            Parse.Cloud.run('certificateRequest', {
              email: payload.schoolEmail,
              studentName: payload.studentName
            })
              .then((res) => {
                console.log(res)
              })
              .catch((error) => {
                // The object was not retrieved successfully.
                // error is a Parse.Error with an error code and message.
                console.log(error)
              })
            commit('setRequestCertificate', saveCertificates)
            commit('setCertificate', response)
          },
          (error) => {
            console.log(error)
            commit('setRequestCertificate', false)
          }
        )
      }
    } catch (error) {
      console.log(error)
      commit('setRequestCertificate', false)
    }
  },

  async getCertificate ({ commit }, payload) {
    const Certificates = Parse.Object.extend('Certificates')
    const query = new Parse.Query(Certificates)

    const User = Parse.Object.extend('User')
    const UserPointerId = new User()
    UserPointerId.id = payload.userId
    query.equalTo('studentId', UserPointerId)

    const Schools = Parse.Object.extend('Schools')
    const SchoolsPointerId = new Schools()
    SchoolsPointerId.id = payload.schoolId
    query.equalTo('schoolId', SchoolsPointerId)

    try {
      const response = await query.first()
      if (response) {
        commit('setCertificate', response)
      } else {
        commit('setCertificate', false)
      }
    } catch (error) {
      console.log(error)
      commit('setCertificate', false)
    }
  },

  async storeBookingRequest ({ commit }, payload) {
    console.log('Values in Method function:', payload)
    const BookingRequests = Parse.Object.extend('BookingRequests')
    const bookingRequest = new BookingRequests()
    const User = Parse.Object.extend('_User')
    const userQuery = new Parse.Query(User)
    const user = await userQuery.get(payload.userId)
    bookingRequest.set('user', user) // Set user pointer
    bookingRequest.set('hoursLesson', payload.hoursLesson)
    bookingRequest.set('availability', payload.availability)
    bookingRequest.set('schoolName', payload.schoolName)
    bookingRequest.set('schoolPackageId', payload.schoolPackageId)
    bookingRequest.set('schoolPackageJoinedId', payload.schoolPackageJoinedId)
    bookingRequest.set('roadTest', payload.roadTest)
    bookingRequest.set('city', payload.city ? payload.city : '')
    const response = await bookingRequest.save()
    /** Let the admin know */
    var message = `${payload.username} has submitted their availability for ${payload.hoursLesson} hour driving lesson`

    Parse.Cloud.run('sendSMS', { message: message }).then(
      (result) => {
        console.log('SMS successful')
      }
    )

    console.log('Booking request saved successfully:', response)
    commit('setBookingRequest', response)
  },

  async getAllBookingRequests () {
    try {
      // Define the BookingRequests class
      const BookingRequests = Parse.Object.extend('BookingRequests')

      // Create a new query for the BookingRequests class
      const query = new Parse.Query(BookingRequests)

      // Optionally, you can add additional query constraints here, e.g., sorting or filtering

      // Fetch all booking requests
      const results = await query.find()
      console.log('All booking requests:', results)

      // Return the results (or commit to store if you're using Vuex)
      return results
    } catch (error) {
      console.error('Error fetching booking requests:', error)
      // Handle error if needed, e.g., return an empty array or throw the error
      return []
    }
  },

  async getAssignedInstructors ({ commit }, payload) {
    try {
      const StudentInstructorAssignments = Parse.Object.extend('StudentInstructorAssignments')
      const query = new Parse.Query(StudentInstructorAssignments)

      const User = Parse.Object.extend('_User')
      const studentPointer = new User()
      studentPointer.id = payload.studentId
      query.equalTo('studentId', studentPointer)

      // Include instructor details
      query.include('instructorId')
      query.limit(50)

      const results = await query.find()
      console.log('Assigned instructors:', results)

      // Extract instructor objects from assignments
      const instructors = results.map(assignment => {
        const instructor = assignment.get('instructorId')
        return {
          id: instructor.id,
          assignmentId: assignment.id,
          firstName: instructor.get('firstName'),
          lastName: instructor.get('lastName'),
          profilePicture: instructor.get('profilePicture'),
          phone: instructor.get('phone'),
          customEmail: instructor.get('customEmail'),
          instructorCities: instructor.get('instructorCities') || [],
          avgRatings: instructor.get('avgRatings') || 0,
          assignedDate: assignment.get('createdAt') || assignment.createdAt
        }
      })

      commit('setAssignedInstructors', instructors)
      return instructors
    } catch (error) {
      console.error('Error fetching assigned instructors:', error)
      commit('setAssignedInstructors', [])
      return []
    }
  },

  /** Get students assigned to an instructor from StudentInstructorAssignments */
  async getAssignedStudents ({ commit }, payload) {
    try {
      const StudentInstructorAssignments = Parse.Object.extend('StudentInstructorAssignments')
      const query = new Parse.Query(StudentInstructorAssignments)

      const User = Parse.Object.extend('_User')
      const instructorPointer = new User()
      instructorPointer.id = payload.instructorId
      query.equalTo('instructorId', instructorPointer)
      query.include('studentId')
      query.ascending('createdAt')
      query.limit(100)

      const results = await query.find()
      const students = results.map(assignment => {
        const student = assignment.get('studentId')
        if (!student) return null
        return {
          id: student.id,
          assignmentId: assignment.id,
          firstName: student.get('firstName') || '',
          lastName: student.get('lastName') || '',
          profilePicture: student.get('profilePicture') || null,
          phone: student.get('phone') || '',
          customEmail: student.get('customEmail') || student.get('email') || '',
          assignedAt: assignment.get('createdAt') || assignment.createdAt
        }
      }).filter(Boolean)

      commit('setAssignedStudents', students)
      return students
    } catch (error) {
      console.error('Error fetching assigned students:', error)
      commit('setAssignedStudents', [])
      return []
    }
  }
}

const mutations = {
  setSchoolPackage: (state, schoolPackage) =>
    (state.schoolPackage = schoolPackage),
  setSchoolInstructors: (state, schoolInstructors) =>
    (state.schoolInstructors = schoolInstructors),
  setSchoolPackageJoined: (state, schoolPackageJoined) =>
    (state.schoolPackageJoined = schoolPackageJoined),
  setSchoolPackageJoinedUpdate: (state, schoolPackageJoinedUpdate) =>
    (state.schoolPackageJoinedUpdate = schoolPackageJoinedUpdate),
  setPaymentHistory: (state, paymenthistory) =>
    (state.paymenthistory = paymenthistory),
  setSchoolPackageJoinedId: (state, schoolPackageJoinedId) =>
    (state.schoolPackageJoinedId = schoolPackageJoinedId),
  setCompletedHours: (state, completedHours) =>
    (state.completedHours = completedHours),
  setRequestCertificate: (state, requestCertificate) =>
    (state.requestCertificate = requestCertificate),
  setCertificate: (state, certificate) => (state.certificate = certificate),
  setSchools: (state, schools) => (state.schools = schools),
  setAssignedInstructors: (state, assignedInstructors) =>
    (state.assignedInstructors = assignedInstructors),
  setAssignedStudents: (state, assignedStudents) =>
    (state.assignedStudents = assignedStudents)
}

export default {
  state,
  getters,
  actions,
  mutations
}
